import { Component } from '@angular/core'
import { File } from '@ionic-native/file'
import { IonicPage, NavController, NavParams, Loading, AlertController, LoadingController, ToastController, Platform } from 'ionic-angular'
import { MessagePriority, Message, HousingUnit, Condominium, User, MessageVisibility, DeviceType, MessageType } from '../../models/models'
import { AuthProvider } from '../../providers/auth/auth'
import { DeviceProvider } from '../../providers/device/device'
import { MessageProvider } from '../../providers/message/message'
import { AudioProvider } from '../../providers/audio/audio'

/**
Per accesso al FS su browser
*/
declare var window: any

/**
* Invia messaggio audioOut
* NOTE: Funziona solo per citofono, eventualmente vanno aggiunte le implementazioni per altre modalità di funzionamento
*/

@IonicPage()
@Component({
	selector: 'page-message-create-audio',
	templateUrl: 'message-create-audio.html',
})
export class MessageCreateAudioPage {
	public recordedFile: string = null;
	public recordedDirectory: string = null;
	public recordedPath: string = null;

	public priority: MessagePriority
	public forwarding: Message
	public housingUnit: HousingUnit = null;
	public user: User = null;
	public condominium: Condominium = null;

	private recordingInterval: number = null;
	private playingInterval: number = null;

	public timePlayed: number = 0;
	public timeRecorded: number = 0;
	public timeMax: number = 60;

	private _isRecording: boolean = false;
	private _isPlaying: boolean = false;

	public get timeActual(): number {
		if(this.isRecording) {
			return this.timeRecorded
		}
		if(this.isPlaying) {
			return this.timePlayed
		}
		return 0//default
	}

	public get timeTotal(): number {
		if(this.isRecording) {
			return this.timeMax
		}
		if(this.isPlaying) {
			return this.timeRecorded
		}
		return this.timeMax//default
	}
	/**
	Messaggio a cui rispondere
	*/
	public message: Message = null;
	public loading: Loading

	public isLoading = true;

	/**
	Ha registrato correttamente
	*/
	public isRecorded: boolean = false;

	public subject: string = 'Audiomessaggio';
	public visibility: MessageVisibility = MessageVisibility.PRIVATE;


	public get isAvailable(): boolean {
		return AudioProvider.isAvailable
	}

	public get isPlaying(): boolean {
		return this._isPlaying || AudioProvider.isPlaying
	}

	public get isRecording(): boolean {
		return this._isRecording || AudioProvider.isRecording
	}

	constructor(
		private alertCtrl: AlertController,
		private auth: AuthProvider,
		//private condominiums:CondominiumProvider,
		//private datePicker: DatePicker,
		public devices: DeviceProvider,
		private file: File,
		private loadingCtrl: LoadingController,
		//public modalCtrl: ModalController,
		private messages: MessageProvider,
		private platform: Platform,
		private navCtrl: NavController,
		private navParams: NavParams,
		private toastCtrl: ToastController
	) {
		this.housingUnit = <HousingUnit>this.navParams.get('housingUnit')

		this.subject = <string>this.navParams.get('subject')
		if(!this.subject) {
			this.subject = 'Nuovo messaggio audio'
		}

		console.debug('[MessageCreateAudio.new()] File provider per la definizione dei percorsi:', this.file)
	}

	public back() {
		this.navCtrl.pop()
	}

	private checkIsRecordedFileExisting(): Promise<boolean> {
		let path = this.recordedPath
		return new Promise((resolve, reject) => {
			window.resolveLocalFileSystemURL(path,
				() => {
					//exists
					console.debug('[MessageCreateAudioPage.checkIsRecordedFileExisting()] Trovato audio del messaggio registrato: ' + path)
					resolve(true)
				},
				() => {
					//not esixts
					console.debug('[MessageCreateAudioPage.checkIsRecordedFileExisting()] File audio del messaggio non trovato: ' + path)
					resolve(false)
				})
		})
	}

	/**
	Ferma e rimuove eventuale timer riproduzione
	*/
	private cleanPlayingInterval() {
		console.log("[MessageCreateAudioPage.cleanPlayingInterval()]")
		if(this.playingInterval) {
			clearInterval(this.playingInterval)
		}
	}

	/**
	Ferma e rimuove eventuale timer registrazione
	*/
	private cleanRecordingInterval() {
		console.log("[MessageCreateAudioPage.cleanRecordingInterval()]")
		if(this.recordingInterval) {
			clearInterval(this.recordingInterval)
		}
	}

	/**
	Se esiste il file della registrazione lo elimina
	*/
	private cleanRecordedFile(): Promise<any> {
		console.debug("[MessageCreateAudioPage.cleanRecordedFile()] Eliminazione dell'eventuale file audiomessaggio..")
		let self = this

		try {
			return new Promise((resolve, reject) => {
				self.checkIsRecordedFileExisting().then(exists => {
					if(exists) {
						console.debug('[AudioProvider.cleanRecordedFile()] Trovata registrazione precedente, la elimino: ' + self.recordedPath)
						self.file.removeFile(self.recordedDirectory, self.recordedFile).then(ok => {
							console.debug('[AudioProvider.cleanRecordedFile().file.removeFile()] Registrazione precedente eliminata.')
							resolve(true)
						}).catch(e => {
							console.error("Errore rimuovendo il file: " + self.recordedPath, e)
							let errorAlert = self.alertCtrl.create({
								title: 'Errore',
								subTitle: "Errore liberando lo spazio per la registrazione",
								buttons: ['OK']
							})
							errorAlert.present()
							resolve(false)
						})
					} else {
						//not esixts
						resolve(true)
					}
				})
			})
		} catch(e) {
			console.error("Errore controllando l'esistenza del file: " + self.recordedPath, e)
			let errorAlert = self.alertCtrl.create({
				title: 'Errore',
				subTitle: "Errore predisponendo la registrazione",
				buttons: ['OK']
			})
			errorAlert.present()
			return Promise.resolve(false)
		}
	}

	ionViewDidEnter() {
		if(!this.housingUnit) {//nessun destinatario possibile, errore ed esce (solo dopo il caricamento)
			console.error('Destinatario per la composizione del messaggio non specificato')
			let errorAlert = this.alertCtrl.create({
				title: 'Errore',
				subTitle: 'Destinatario mancante, impossibile creare il messaggio',
				buttons: ['OK']
			})
			errorAlert.present()

			this.navCtrl.pop()
			return
		}
		this.isLoading = false
	}

	ionViewWillEnter() {
	}

	/**
	Uscita dal primo piano
	*/
	ionViewDidLeave() {
		console.debug("[MessageCreateAudioPage.ionViewWillUnload()] Libero le risorse..")
		let self = this

		//deassocia i listener
		AudioProvider.detach(this)

		this.stop().then(path => {
			self.cleanRecordedFile()
		})

		switch(this.devices.actualType) {
			case DeviceType.DASHBOARD:
			case DeviceType.INTERCOM:
				if(this.auth.user) {
					this.auth.logout()
				}
				break
		}
	}

	/**
	Riproduce la registrazione
	*/
	public startPlaying(): Promise<boolean> {
		console.debug("[MessageCreateAudioPage.startPlaying()]")
		if(!this.platform.is('cordova')) {
			console.warn('Esecuzione fake su browser')
			this._isPlaying = true
			this.startPlayingInterval()
			return Promise.resolve(true)
		}

		if(!this.recordedPath || !this.isRecorded) {
			return Promise.resolve(false)
		}

		let self = this

		return new Promise((resolve, reject) => {
			this.stop().then(() => {//ferma eventuali registrazioni o riproduzioni
				self.startPlayingInterval()
				AudioProvider.onStopPlaying.once(this, () => {
					console.debug('[MessageCreateAudioPage.startPlaying().onStopPlaying()] Riproduzione audiomessaggio terminata')
					self._isPlaying = false
					self.cleanPlayingInterval()
				})

				AudioProvider.startPlaying(this.recordedPath).then(() => {
					console.debug('[MessageCreateAudioPage.startPlaying().onStopPlaying()] Riproduzione audiomessaggio avviata: ' + this.recordedPath)
					resolve(true)
				}).catch(e => {
					console.error("[MessageCreateAudioPage.startPlaying().AudioProvider().startPlaying()] Errore avviando la riproduzione del file: " + this.recordedPath, e)
					resolve(false)
				})
			})
		})
	}

	/**
	Avvia il timer di riproduzione, a soli fini grafici
	*/
	private startPlayingInterval() {
		console.debug("[MessageCreateAudioPage.startPlayingInterval()]")
		let self = this

		this.timePlayed = 0

		this.playingInterval = window.setInterval(() => {
			console.debug('[MessageCreateAudioPage.playingInterval] Eseguiti ' + self.timePlayed + ' secondi..')
			if(++self.timePlayed >= self.timeTotal) {
				console.debug('[MessageCreateAudioPage.playingInterval] Tempo massimo audiomessaggio raggiunto')
				self.cleanPlayingInterval()//stop automatico, elimina soltanto l'interval
			}
		}, 1000)
	}

	/**
	Avvia la registrazione
	*/
	public startRecording() {
		console.debug("[MessageCreateAudioPage.startRecording()]")

		let self = this

		this.stop().then(() => {
			this.recordedFile = 'messageAudio.3gp'
			this.isRecorded = false

			if(!self.platform.is('cordova')) {
				console.warn('Registrazione fake su browser')
				self._isRecording = true
				self.startRecordingInterval()
				return

				/*
				let requestFileSystem = window.requestFileSystem ? window.requestFileSystem : window.webkitRequestFileSystem;
				if (!requestFileSystem) {
				console.error('Funzione non supportata su questo dispositivo')
				return;
			}

			requestFileSystem(window.TEMPORARY, 5 * 1024 * 1024, function(fs) {
			console.log('Accesso al file system ottenuto: ' + fs.name, fs);

			fs.root.getFile(self.recordedFile, { create: true, exclusive: false }, function(fileEntry) {
			// fileEntry.isFile === true
			// fileEntry.name == 'log.txt'
			// fileEntry.fullPath == '/log.txt'
			//self.recordedFile = fileEntry.name;
			self.recordedPath = fileEntry.fullPath;
			self.recordedDirectory = fileEntry.fullPath.substring(0, fileEntry.name.length)
			checkAndStart()
			}, (e) => {
			console.error('Errore richiedendo di accedere al file system: ', e)
			});
			});
			*/
			}

			//quando ok avvia la registrazione con questa lambda
			let start = () => {
				console.debug('[AudioProvider.startRecording().start()] Avvio la registrazione in: ' + self.recordedPath)

				//listener per verificare la corretta produzione del file
				AudioProvider.onStopRecording.once(this, path => {
					self._isRecording = false

					this.checkIsRecordedFileExisting().then(exists => {
						self.isRecorded = exists
						if(exists) {
							console.debug('[MessageCreateAudioPage.startRecording().onStopRecording()] Trovato audio del messaggio registrato: ' + self.recordedPath)
						} else {
							//not esixts
							console.error('[MessageCreateAudioPage.startRecording().onStopRecording()] File audio del messaggio mancante: ' + self.recordedPath)
							let errorAlert = self.alertCtrl.create({
								title: 'Errore',
								subTitle: "Errore recuperando il messaggio registrato",
								buttons: ['OK']
							})
							errorAlert.present()
						}
					})
				})

				//avvia registrazione
				AudioProvider.startRecording(self.recordedPath).then(path => {
					self._isRecording = true
					self.startRecordingInterval()
				}).catch(e => {
					console.error("Errore durante la registrazione dell'audio del messaggio", e)
					let errorAlert = self.alertCtrl.create({
						title: 'Errore durante la registrazione',
						subTitle: 'Impossibile registrare l\'audio in questo momento',
						buttons: ['OK']
					})
					errorAlert.present()
					self.navCtrl.pop()
				})
			}

			if(this.platform.is('android')) {
				this.recordedDirectory = this.file.externalDataDirectory//this.file.dataDirectory;//this.file.cacheDirectory;//this.file.dataDirectory.replace(/file:\/\//g, '');
				this.recordedPath = this.recordedDirectory + this.recordedFile
				this.cleanRecordedFile().then(ok => {
					if(ok) {
						start()
					} else {
						console.warn('Errore durante la preparazione del file, non eseguo la registrazione')
					}
				})
			} else {
				console.error('Funzione di registrazione non supportata su questo dispositivo')
			}
		})
	}

	/**
	Avvia il timer di registrazione, usato a fini grafici e per massimizzare la lunghezza del messaggio
	*/
	private startRecordingInterval() {
		console.debug("[MessageCreateAudioPage.startRecordingInterval()]")
		let self = this

		this.timeRecorded = 0

		this.recordingInterval = window.setInterval(() => {
			console.debug('[MessageCreateAudioPage.timerInterval] Registrati ' + self.timeRecorded + ' secondi..')
			if(++self.timeRecorded >= self.timeTotal) {
				console.debug('[MessageCreateAudioPage.timerInterval] Tempo massimo audiomessaggio raggiunto')
				self.stopRecording()
			}
		}, 1000)
	}

	/**
	Ferma eventuale registrazione o esecuzione
	*/
	public stop(): Promise<boolean[]> {
		console.debug('[MessageCreateAudioPage.stop()] Fermo eventuali registrazioni o riproduzioni..')

		let wait = [
			this.stopRecording(),
			this.stopPlaying()
		]
		return Promise.all(wait)
	}

	/**
	Ferma la riproduzione e rimuove il relativo timer

	true se era effettivamente attiva
	*/
	private stopPlaying(): Promise<boolean> {
		this.cleanPlayingInterval()

		let was = this._isPlaying
		this._isPlaying = false

		if(!this.platform.is('cordova')) {
			return Promise.resolve(was)
		}

		let result = AudioProvider.stopPlaying()
		return result
	}

	/**
	Ferma la registrazione e rimuove il relativo timer

	true se era effettivamente attiva
	*/
	private stopRecording(): Promise<boolean> {
		console.debug('[MessageCreateAudioPage.stopRecording()] Fermo la registrazione..')
		this.cleanRecordingInterval()


		let result = AudioProvider.stopRecording()
		let was = this._isRecording
		this._isRecording = false

		if(!this.platform.is('cordova')) {
			this.isRecorded = true
			return Promise.resolve(was)
		}
		if(!this.recordedPath) {//registrazione non inizializzata: bypassa il controllo del file
			return Promise.resolve(false)
		}

		return result
	}

	/**
	Invia il messaggio
	*/
	public send() {
		let self = this
		this.loading = this.loadingCtrl.create({
			content: 'Invio in corso...',
			dismissOnPageChange: false
		})
		this.loading.present()

		let body = "Audiomessaggio"

		if(this.condominium) {
			body += ' per ' + this.condominium.name
		}

		if(this.housingUnit) {
			if(this.housingUnit.label) {
				body += ' per ' + this.housingUnit.label
			} else {
				body += ' ai residenti'
			}

			if(this.housingUnit.floor) {
				body += ', piano ' + this.housingUnit.floor
			}
			if(this.housingUnit.stair) {
				body += ', scala ' + this.housingUnit.stair
			}
			if(this.housingUnit.internal) {
				body += ', interno ' + this.housingUnit.internal
			}
		}

		if(this.user) {
			body += ' per ' + this.user.name + ' ' + this.user.surname
		}



		this.messages.sendToHousingUnit(
			this.housingUnit,
			body,
			this.subject,
			this.message,
			MessageType.AUDIO,
			this.recordedPath
		).then((message: Message) => {
			self.loading.dismiss()
			if(message) {
				//TODO Allegare il file e quindi eliminarlo

				let toast = this.toastCtrl.create({
					message: "Messaggio inviato all'unità abitativa",
					position: 'middle',
					duration: 3000
				})
				toast.present()
				self.navCtrl.pop()
			} else {
				let errorAlert = self.alertCtrl.create({
					title: 'Errore',
					subTitle: "Impossibile inivare il messaggio in questo momento",
					buttons: ['OK']
				})
				errorAlert.present()
			}
		}, error => {
			self.loading.dismiss()
			let errorAlert = self.alertCtrl.create({
				title: 'Errore',
				subTitle: error,
				buttons: ['OK']
			})
			errorAlert.present()
		})
	}
}



// WEBPACK FOOTER //
// ./src/pages/message-create-audio/message-create-audio.ts